import {useUrlCreator} from '@github-ui/code-view-shared/hooks/use-url-creator'
import {addUrlToHistoryStack} from '@github-ui/history'
import {GlobalCommands} from '@github-ui/ui-commands'
import {useCallback} from 'react'

export function PermalinkShortcut() {
  const urlCreator = useUrlCreator()

  const handlePermalink = useCallback(() => {
    if (urlCreator.isCurrentPagePermalink()) {
      // no-op so that the user isn't moved to the bottom of the page
      return
    }
    const permalink = urlCreator.createPermalink()
    if (window.location.href.indexOf(permalink) < 0) {
      addUrlToHistoryStack(permalink)
    }
  }, [urlCreator])

  return <GlobalCommands commands={{'code-view:permalink': handlePermalink}} />
}
